const rankings = [
  { rank: 1, title: '暗夜追踪', tag: '悬疑', hot: '9.8', update: '第12集更新', trend: 'up' },
  { rank: 2, title: '星海迷途', tag: '科幻', hot: '9.7', update: '第8集更新', trend: 'up' },
  { rank: 3, title: '午夜食堂', tag: '温情', hot: '9.6', update: '全24集完结', trend: 'hot' },
  { rank: 4, title: '极限追凶', tag: '犯罪', hot: '9.5', update: '第16集更新', trend: 'up' },
  { rank: 5, title: '月光恋人', tag: '爱情', hot: '9.4', update: '全16集完结', trend: 'stable' },
  { rank: 6, title: '城市夜话', tag: '纪录', hot: '9.3', update: '第5集更新', trend: 'up' },
  { rank: 7, title: '深夜脱口秀', tag: '综艺', hot: '9.2', update: '每周五更新', trend: 'hot' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            热度飙升榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            深夜时段最受欢迎的高分影视作品实时排行
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 transition-colors duration-200 cursor-pointer hover:bg-background-100 ${
                i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-accent-500 text-background-50' :
                'bg-secondary-200 text-foreground-700'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-primary-50 text-primary-600 text-[10px] font-medium flex-shrink-0">
                    {item.tag}
                  </span>
                  {item.trend === 'hot' && (
                    <i className="ri-fire-fill text-accent-500 text-xs flex-shrink-0"></i>
                  )}
                  {item.trend === 'up' && (
                    <i className="ri-arrow-up-fill text-primary-500 text-xs flex-shrink-0"></i>
                  )}
                </div>
                <p className="text-xs text-foreground-400 mt-0.5">{item.update}</p>
              </div>

              <div className="flex items-center gap-1 flex-shrink-0">
                <i className="ri-star-fill text-primary-400 text-sm"></i>
                <span className="text-sm font-bold text-primary-600">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}